import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FPC } from '../../../../app.constants';
import { ConsultaExtratoPreviModel } from '../../../shared/models/consulta-extrato-previ.model';
import { OcorRemidoWebModel } from '../../../shared/models/orco-remido-web.model';
import { RemidoWebModel } from '../../../shared/models/remido-web.model';


@Injectable()
export class FpcService {


  constructor(private httpClient: HttpClient) { }


  getConsultaRemido(cdCentrus: number): Promise<RemidoWebModel> {
    return this.httpClient
      .get<RemidoWebModel>(`${FPC}/consultaRemido/${cdCentrus}`)
      .toPromise();
  }

  getObterSituacaoFuncBacen(cdCentrus: number) {
    return this.httpClient
      .get(`${FPC}/obterSituacaoFuncBacen/${cdCentrus}`)
      .toPromise();
  }

  getBuscarDestinoPagto(cdCentrus: number) {
    return this.httpClient
      .get(`${FPC}/buscarDestinoPagto/${cdCentrus}`)
      .toPromise();
  }

  getConsultaOcorrenciasRemido(cdCentrus: number): Promise<OcorRemidoWebModel[]> {
    return this.httpClient
      .get<OcorRemidoWebModel[]>(`${FPC}/consultaOcorrenciasRemido/${cdCentrus}`)
      .toPromise();
  }

  getPageConsultaOcorrenciasRemido(cdCentrus: number, linesPerPage: number, page: number): Promise<OcorRemidoWebModel[]> {
    return this.httpClient
      .get<OcorRemidoWebModel[]>(`${FPC}/page/consultaOcorrenciasRemido/${cdCentrus}?linesPerPage=${linesPerPage}&page=${page}`)
      .toPromise();
  }

  getConsultaExtratoPrevi(cdCentrus: number): Promise<ConsultaExtratoPreviModel[]> {
    return this.httpClient
      .get<ConsultaExtratoPreviModel[]>(`${FPC}/consultaExtratoPrevi/${cdCentrus}`)
      .toPromise();
  }

  getObterOcorFatReversao(cdCentrus: number, tpOcorrencia: number): Promise<OcorRemidoWebModel[]> {
    return this.httpClient
      .get<OcorRemidoWebModel[]>(`${FPC}/obterOcorFatReversao/${cdCentrus}/${tpOcorrencia}`)
      .toPromise();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/planos/fpc/service/fpc.service.ts